export const addDaysToDate = (dateVal, days) => {
  if (!dateVal && dateVal !== 0) return '';
  try {
    let date;
    if (typeof dateVal === 'number') {
      const excelEpoch = new Date(1899, 11, 30);
      date = new Date(excelEpoch.getTime() + dateVal * 24 * 60 * 60 * 1000);
    } else if (dateVal instanceof Date) {
      date = new Date(dateVal);
    } else if (typeof dateVal === 'string') {
      const str = dateVal.trim();
      if (str.includes('/')) {
        const parts = str.split('/');
        if (parts.length === 3) {
          const month = parseInt(parts[0], 10);
          const day = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          date = new Date(year, month - 1, day);
        }
      } else {
        date = new Date(str);
      }
    }
    if (!date || isNaN(date.getTime())) return '';
    date.setDate(date.getDate() + days);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  } catch (e) {
    return '';
  }
};

export const formatDateValue = (dateVal) => {
  if (!dateVal && dateVal !== 0) return '';
  try {
    let date;
    if (typeof dateVal === 'number') {
      const excelEpoch = new Date(1899, 11, 30);
      date = new Date(excelEpoch.getTime() + dateVal * 24 * 60 * 60 * 1000);
    } else if (dateVal instanceof Date) {
      date = dateVal;
    } else if (typeof dateVal === 'string') {
      const str = dateVal.trim();
      if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) return str;
      if (str.includes('/')) {
        const parts = str.split('/');
        if (parts.length === 3) {
          const month = parseInt(parts[0], 10);
          const day = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          date = new Date(year, month - 1, day);
        }
      } else {
        date = new Date(str);
      }
    }
    if (!date || isNaN(date.getTime())) return String(dateVal);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  } catch (e) {
    return String(dateVal);
  }
};

export const transformPOData = (rawData, config) => {
  return rawData.map(row => {
    const transformed = {};
    config.outputColumns.forEach(col => {
      if (col.type === 'blank') {
        transformed[col.name] = '';
      } else if (col.type === 'field') {
        const val = row[col.source] || '';
        if (col.name === 'datecreated' && val) {
          transformed[col.name] = formatDateValue(val);
        } else {
          transformed[col.name] = val;
        }
      } else if (col.type === 'calculated' && col.calc === 'addDays') {
        transformed[col.name] = addDaysToDate(row[col.source], col.days);
      }
    });
    return transformed;
  });
};